<template>
  <p-child nested namespace="il-wizard" class="il-wizard-step">
    <p-container class="pt-1">
      <slot></slot>
    </p-container>
    <div class="mt-4">
      <p-divider></p-divider>
      <p-container fluid>
        <p-row no-gutters>
          <p-col shrink class="pr-4">
            <slot name="back-action">
              <p-button
                v-if="$media.isNotMobile"
                :disabled="isBackDisabled || isLoading"
                :loading="isLoading"
                class="mr-3"
                secondary
                @click="goBack"
              >
                <p-icon left>
                  chevron_left
                </p-icon>{{ $t('app.back') }}
              </p-button>
            </slot>
            <slot name="step-actions" :is-loading="isLoading" :proceed-disabled="proceedDisabled">
              <p-button
                :loading="isLoading"
                :disabled="proceedDisabled || isLoading"
                @click="proceedOrComplete"
              >
                {{ isLastStep ? $t('app.saveAndComplete') : $t('app.saveAndContinue') }}
                <p-icon right>
                  {{ isLastStep ? 'send' : 'chevron_right' }}
                </p-icon>
              </p-button>
            </slot>
          </p-col>
          <p-col grow>
            <p-request-alert v-model="errorResponse" :dismissable="false"></p-request-alert>
          </p-col>
        </p-row>
      </p-container>
    </div>
  </p-child>
</template>

<script lang="ts">
  import Vue from 'vue';
  import { StepData } from './il-wizard.vue';

  export default Vue.extend({
    props: {
      value: { type: Object, default: undefined },
      proceedDisabled: { type: Boolean, default: false },
      loading: { type: Boolean, default: false },
    },
    data: () => ({
      stepData: {} as Partial<StepData>,
      // eslint-disable-next-line no-unused-vars
      proceedFunction: undefined as undefined | (() => void),
      backFunction: undefined as undefined | (() => void),
      // eslint-disable-next-line no-unused-vars
      completeFunction: undefined as undefined | (() => void),
      isLastStep: false,
      isFirstStep: false,
      isBackDisabled: false,
      errorResponse: undefined as any,
      wizardIsLoading: false,
    }),
    computed: {
      isLoading(): boolean {
        return this.wizardIsLoading || this.loading;
      },
    },
    methods: {
      goBack() {
        if (this.backFunction) {
          this.backFunction();
        }
      },
      proceedOrComplete() {
        if (this.isLastStep) {
          this.complete();
        } else {
          this.proceed();
        }
      },
      proceed() {
        if (typeof this.proceedFunction === 'function') {
          this.proceedFunction();
        }
      },
      complete() {
        if (typeof this.completeFunction === 'function') {
          this.completeFunction();
        }
      },
    },
  });
</script>
